import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class DataService {
  public tableconfig = [];
  public tabledata = [];
  public dataChange: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public dialogData = {};

  private columnDictionary: { [id: string]: string } = {};

  constructor() {}

  public initData(tableConfig: any, tableData: any) {
    this.dataChange = new BehaviorSubject<any[]>([]);
    this.tableconfig = tableConfig;
    this.tabledata = tableData;
    this.constructColumnDictionary();
    this.addOriginalDataToDataChangeWithId();
  }

  // Get

  public getDialogData() {
    return this.dialogData;
  }

  public getAllCurrentData() {
    return this.dataChange.value;
  }

  public getTableConfiguration() {
    return this.tableconfig;
  }

  public getColumnHeaders() {
    return this.getColumnConfigData('header');
  }

  public getColumnNamesWithRowId() {
    return this.getColumnConfigData('name');
  }

  public getColumnNamesWithoutRowId() {
    const columnNames: string[] = this.getColumnConfigData('name');
    const index: number = columnNames.indexOf('catchindex');
    if (index !== -1) {
      columnNames.splice(index, 1);
    }
    return columnNames;
  }

  public getColumnHeadersWithNames() {
    const config = this.getTableConfiguration();
    const columnCount = Object.keys(config).length;

    const coulmnDataArray: {}[] = [];

    for (const key in config) {
      coulmnDataArray.push({
        header: config[key]['header'],
        name: config[key]['name'],
        type: config[key]['type'],
      });
    }
    coulmnDataArray.push({ header: 'Catch Index', name: 'catchindex' });
    return coulmnDataArray;
  }

  // CRUD Operations
  public addRecord(newData: any) {
    newData['catchindex'] = this.generateNewGUID24();
    this.dialogData = newData;
  }

  public updateRecord(editData: any) {
    this.dialogData = editData;
  }

  deleteRecord(deleteData: any) {}

  // help
  public changeKeyToNumeric(changeKeyData: { data: { [key: string]: any } }) {
    const newDataRow: { [key: number]: any } = {};
    const colNames: string[] = this.getColumnNamesWithRowId();

    for (let index = 0; index < colNames.length; ++index) {
      const colName = colNames[index];
      newDataRow[index] = changeKeyData.data[colName];
    }

    return newDataRow;
  }

  public getDeepCopy(obj: any) {
    return JSON.parse(JSON.stringify(obj));
  }

  // private Helpers
  private generateNewGUID24(): string {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return s4() + s4() + s4();
  }

  private getColumnConfigData(attribute: string) {
    const config = this.getTableConfiguration();
    const coulmnDataArray = [];

    for (const key in config) {
      coulmnDataArray.push(config[key][attribute]);
    }
    coulmnDataArray.push('catchindex');
    return coulmnDataArray;
  }

  private addOriginalDataToDataChangeWithId() {
    const tableData = this.tabledata;
    if (tableData) {
      tableData.forEach((dataRow: any) => {
        dataRow['catchindex'] = this.generateNewGUID24();
        this.dataChange.value.push(dataRow);
      });
    }
  }

  private constructColumnDictionary() {
    const columns = this.getColumnNamesWithRowId();
    for (let i = 0; i < columns.length; ++i) {
      this.columnDictionary[i] = columns[i];
    }
  }
}
